import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SvgIconComponent } from '../../shared/components/svg-icon/svg-icon.component';

import { ISvgConfig } from '../../shared/interfaces/svg.interfaces';

import { ESvgTypes } from '../../shared/enums/svg.enums';
import { ETermsOfService } from '../../enums/terms-of-service.enums';

@Component({
  selector: 'stxt-footer',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  public instagramSvg: ISvgConfig = { name: 'instagram', fill: ESvgTypes.Outlined };
  public xSvg: ISvgConfig = { name: 'x', fill: ESvgTypes.Outlined };
  public availablePayments: string[] = ['Visa', 'Mastercard'];
  public instagramUrl: string = 'https://www.instagram.com/justsext.app';
  public xUrl: string = 'https://x.com/justsext';
  public footerLinks: { title: string; url: string }[] = [
    {
      title: 'Terms & Conditions',
      url: ETermsOfService.TermsOfUse
    },
    {
      title: 'Privacy Policy',
      url: ETermsOfService.Privacy
    },
    {
      title: 'Content Removal Policy',
      url: ETermsOfService.ContentRemovalPolicy
    },
    {
      title: 'Complaints Policy',
      url: ETermsOfService.ComplaintsPolicy
    },
    {
      title: 'Payment Policy',
      url: ETermsOfService.PaymentPolicy
    },
    {
      title: 'Help Center',
      url: ETermsOfService.HelpCenter
    },
    {
      title: '18 U.S.C. §2257 Notice',
      url: ETermsOfService.ComplianceNotice
    }
  ];
  public stxtLinks: { header: string; title: string; url: string }[] = [
    {
      header: 'Creators',
      title: 'Create your AI',
      url: 'https://creators.justsext.com/'
    },
    {
      header: 'Agencies',
      title: 'Partnership inquiries',
      url: 'https://agencies.justsext.com/'
    },
    {
      header: 'Affiliates',
      title: 'Marketing program',
      url: 'https://affiliates.justsext.com/'
    }
  ];
}
